import React from "react";
import fb from "../../lib/firebase";
import {
  IonButton,
  IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle,
  IonContent, IonDatetime,
  IonHeader, IonIcon, IonList,
  IonMenuButton,
  IonPage, IonProgressBar,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import {EventoObject} from "../../models/Evento";
import {cardContent} from "./EventoCard";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";
import {DateTime} from "luxon";
import {getColectionIcon, pluralize} from "../../lib/utils";
import styles from "../Agenda/TarefaCard.module.css";
import {home} from "ionicons/icons";


interface Props {
  history: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  loading: boolean;
  colecao: any[];
  colecaoFiltrada: any[] | undefined;
  data: string | undefined;
  datasAtivas: string[];
}

class Eventos extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props:Props) {
    super(props);

    this.state = {
      loading: false,
      colecao: [],
      colecaoFiltrada: undefined,
      data: undefined,
      datasAtivas: [],
    };

    this.cancelListener = () => {};
  }

  componentDidMount() {
    this.installListener();
  }

  componentWillUnmount() {
    this.cancelListener();
  }

  installListener = () => {
    this.setState({loading: true});
    const query = fb.db.collection('eventos')
      .where('owner', '==', this.props.app.user.uid)
      .orderBy('data', 'desc')

    this.cancelListener = query.onSnapshot(snap => {
      const colecao = fb.col(snap);
      this.setState({colecao, loading: false}, () => {
        this.setDatasAtivas();
      });
    });
  };

  filtrarColecao = () => {
    let colecaoFiltrada: any[];
    if (this.state.data) {
      const data = DateTime.fromISO(this.state.data);
      colecaoFiltrada = this.state.colecao.filter(i => DateTime.fromJSDate(i.data.toDate()).hasSame(data, 'day'));
    } else {
      colecaoFiltrada = this.state.colecao;
    }
    this.setState({
      colecaoFiltrada: colecaoFiltrada,
    });
  }

  setDatasAtivas = () => {
    const datasAtivas: string[] = [];
    let firstData: string | undefined = undefined;
    this.state.colecao.forEach(i => {
      const d = DateTime.fromJSDate(i.data.toDate());
      if (!firstData)
        firstData = d.toISO();
      const key = d.toFormat('yyyy-MM-dd');
      if (datasAtivas.indexOf(key) === -1) {
        datasAtivas.push(key);
      }
    });
    const newState: any = {datasAtivas};

    if (firstData) {
      const key = DateTime.fromISO(firstData).toFormat('yyyy-MM-dd');
      if (!this.state.data || datasAtivas.indexOf(key) === -1)
        newState.data = firstData;
    } else {
      // reset
      newState.data = undefined;
    }

    this.setState(newState, this.filtrarColecao);
  }

  onClickEvento = (instance: EventoObject) => {
    this.props.dispatch(actions.jump('/eventos'));
    this.props.history.push(`/eventos/${instance.id}/home`);
  };

  onClickPrincipal = (instance: EventoObject) => {
    this.props.dispatch(actions.jump('/eventos'));
    this.props.history.push(`/${instance.principal.path.path}/home`);
  };

  onChangeData = (data: string) => {
    this.setState({data}, this.filtrarColecao);
  }

  isDateEnabled = (data: string) => {
    const key = DateTime.fromISO(data).toFormat('yyyy-MM-dd');
    return this.state.datasAtivas.indexOf(key) !== -1;
  }

  render() {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton/>
            </IonButtons>
            <IonTitle>
              Histórico
            </IonTitle>
            <IonIcon
              icon={home}
              slot="primary"
              class="pr-3 text-2xl"
              onClick={() => this.props.history.push('/home')}
            />
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {this.state.data &&
            <div className="mb-4 flex justify-center">
              <IonDatetime
                presentation="date"
                value={this.state.data}
                onIonChange={(e: any) => this.onChangeData(e.detail.value)}
                isDateEnabled={this.isDateEnabled}
              />
            </div>
          }

          {this.state.colecaoFiltrada === undefined &&
            <IonProgressBar type="indeterminate" />
          }

          <div>
            {this.state.colecaoFiltrada !== undefined && !this.state.colecaoFiltrada.length &&
              <div className="text-center mt-6 italic">
                Nenhum evento registrado até o momento.
              </div>
            }
            {this.state.colecaoFiltrada !== undefined && !!this.state.colecaoFiltrada.length && this.state.data &&
              <>
                <div className="px-4 flex justify-between items-baseline">
                  <div className="text-xl">
                    {DateTime.fromISO(this.state.data).setLocale('pt-br').toFormat("dd 'de' MMMM 'de' yyyy")}
                  </div>
                  <div className="text-xs opacity-75">
                    {this.state.colecaoFiltrada.length} {pluralize('evento', this.state.colecaoFiltrada.length)}
                  </div>
                </div>
                <IonList>
                  {
                    this.state.colecaoFiltrada.map(i => (
                      <IonCard
                        key={i.id}
                      >
                        <IonCardHeader>
                          <IonCardSubtitle>
                            {i.tipo}
                          </IonCardSubtitle>
                          <IonCardTitle>
                            {i.descricao}
                          </IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                          <div className="font-bold">{i.principal.label}</div>
                          {cardContent(i)}
                          <div className="flex items-center gap-6 justify-center mt-4 h-9">
                            <IonButton
                              shape="round"
                              size="small"
                              className={styles.btAction}
                              color="success"
                              onClick={() => this.onClickPrincipal(i)}
                            >
                              <IonIcon src={getColectionIcon(i.principal.path.parent.id)} slot="start"/>
                              Cliente
                            </IonButton>
                            <IonButton
                              shape="round"
                              size="small"
                              className={styles.btAction}
                              color="secondary"
                              onClick={() => this.onClickEvento(i)}
                            >
                              <IonIcon src={getColectionIcon('eventos')} slot="start"/>
                              Evento
                            </IonButton>
                          </div>
                        </IonCardContent>
                      </IonCard>
                    ))
                  }
                </IonList>
              </>
            }
          </div>
        </IonContent>
      </IonPage>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(Eventos);